




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Copy from "@/components/copy.vue";
import { getZhuanjia } from "@/request/idr";
@Component({
  components: {
    Copy
  }
})
export default class IdrBiaozhuPreview extends Vue {
  @Prop()
  private tongueId: any;
  @Prop()
  private patient: any;
  private cPart: any = "舌象信息输出";
  private message: any = {
    舌象照片: {}
  };
  /**
   * @description 获取信息
   */
  private fetchMessage() {
    const params: any = {
      params: {
        tongue_id: this.tongueId
      }
    };
    getZhuanjia(this, params).then((data: any) => {
      console.log(data);
      this.message = data;
    });
  }
  /**
   * @description 改变显示模块
   */
  private changePart(part) {
    this.cPart = part;
  }
  /**
   * @description 关闭预览
   */
  private close() {
    this.$emit("close");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchMessage();
  }
}
